import { Stack, Tooltip, Typography } from '@cmg/design-system';
import React from 'react';

import type { FundItem } from '../../../FundLevelDemand';
import { DemandItem } from './DemandItem';

export type Props = {
  iois: FundItem['iois'];
};

export const DemandItemTooltip: React.FC<Props> = ({ iois }) => {
  return (
    <Tooltip
      variant="info"
      title={
        <Stack>
          {iois.map(ioi => (
            <DemandItem key={ioi.id} ioi={ioi} />
          ))}
        </Stack>
      }
      placement="top"
    >
      <Typography color="text.primary"> +{iois.length} </Typography>
    </Tooltip>
  );
};
